import { render, staticRenderFns } from "./GroupFlightList.vue?vue&type=template&id=33b2542a&"
import script from "./GroupFlightList.vue?vue&type=script&lang=js&"
export * from "./GroupFlightList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports